import { FC } from 'react';

import { ConfigField, ConfigSlideId } from '@/eventConfig/types.ts';
import { RenderField } from '@/form/fields/RenderField.tsx';

interface EditDataField {
  field: ConfigField;
  slideId: ConfigSlideId;
}

export const EditDataField: FC<EditDataField> = ({ field, slideId }) => {
  const noLabel = {
    ...field,
    label: '',
  };

  return <RenderField slideId={slideId} field={noLabel} />;
};
